import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import {
    FormControl,
    // InputLabel,
    Popover,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import PTMButton from "../PTMButton";

const StyledFormControl = styled(FormControl, {
    shouldForwardProp: (prop) => !["darkMode", "disabled", "label"].includes(prop),
})(({
    theme, darkMode, disabled,
    // label,
    focused,
}) => ({
    "& .MuiButton-root": {
        height: 24,
        width: 24,
        borderColor: "rgba(255, 255, 255, 0.23)",
        borderWidth: 1,
        borderStyle: "solid",
    },
    "& .Mui-disabled": {
        color: `${theme.palette.text.primary}!important`,
        WebkitTextFillColor: "initial",
    },
    margin: 0,

    "& .hide": {
        borderColor: darkMode ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.26)",
        borderRadius: 4,
        minHeight: 50,
        display: "initial!important",
        "& *": {
            visibility: "hidden",
        },
    },
    "& .tox-tinymce": {
        borderColor: darkMode ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.26)",
        borderRadius: 4,
        marginTop: -1,
        visibility: "inherit",
        minHeight: 50,
        // ...label ? {
        //     marginTop: 14,
        // } : {
        //     marginTop: 1,
        // },
        ...focused && {
            borderColor: "#4594ad",
            borderWidth: 2,
        },
    },
    "& .tox-tinymce:hover": {
        borderColor: disabled ? (darkMode ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.26)") : (darkMode ? "rgb(255, 255, 255)" : "rgba(0, 0, 0, 0.87)"),
        ...focused && {
            borderColor: "#4594ad",
            borderWidth: 2,
        },
    },
    "& .tox-toolbar__primary": {
        // color: darkMode ? "#ffffff80!important" : "#222f3e80",
        // background: darkMode ? "#272b30!important" : "#fff!important",
        // borderBottom: "1px solid #ccc",
    },
    "& .tox-tbtn": {
        height: "20px !important",
    },
    "& .tox-editor-header": {
        borderBottom: "1px solid #ccc",
        ...disabled && {
            visibility: "hidden",
        },
    },
    "& .tox-statusbar": {
        bottom: 0,
        right: 0,
        position: "absolute",
        background: "none",
        border: "none",
        "& .tox-statusbar__text-container": {
            display: "none",
        },
    },
    // ...label && {
    //     "& .MuiInputLabel-shrink": {
    //         fontSize: 12,
    //         transform: "translate(2px, -7px) scale(1) !important",
    //     },
    // },
    ...disabled && {
        "& .tox-sidebar-wrap": {
            marginTop: -40,
        },
    },
}));

const icons = new Set(Object.keys(fas).map((item) => fas[item].iconName));

function PTMIconPicker(props) {
    const {
        // label,
        value, onChange, onBlur, disabled, required, inputRef, error,
    } = props;

    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [iconNotAvailable, setIconNotAvailable] = useState(false);

    useEffect(() => {
        if (value === "" || !icons.has(value)) {
            setIconNotAvailable(true);
        } else {
            setIconNotAvailable(false);
        }
    }, [value]);

    const handlePopoverOpen = (e) => {
        setPopoverAnchor(e.currentTarget);
    };

    const handlePopoverClose = () => {
        setPopoverAnchor(null);
        onBlur();
    };

    const selectIcon = (selectedIcon) => {
        onChange(selectedIcon);
        setPopoverAnchor(null);
    };

    return (
        <StyledFormControl
            required={required}
            error={error}
            // className={[classes.editor, label ? classes.label : classes.noLabel, focused ? classes.focused : "", disabled ? classes.disabled : ""]}
        >
            {/* {label ? ( */}
            {/*    <InputLabel className={[disabled ? "Mui-disabled" : ""]}> */}
            {/*        {label} */}
            {/*    </InputLabel> */}
            {/* ) : null} */}
            <PTMButton
                variant="contained"
                popover="Icon auswählen"
                disabled={disabled}
                onClick={(e) => handlePopoverOpen(e)}
            >
                <FontAwesomeIcon
                    icon={iconNotAvailable ? "" : value}
                    title="Icon auswählen"
                    ref={inputRef}
                />
            </PTMButton>
            {popoverAnchor ? (
                <Popover
                    id="mouse-over-popover"
                    open={!!popoverAnchor}
                    anchorEl={popoverAnchor}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                    onClose={handlePopoverClose}
                >
                    {!required && value && (
                        <PTMButton
                            variant="contained"
                            color="error"
                            sx={{
                                width: "100%",
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                            }}
                            onClick={() => selectIcon("")}
                        >
                            Entfernen
                        </PTMButton>
                    )}
                    <div style={{
                        overflow: "auto",
                        height: "calc(100% - 30px)",
                        padding: 2,
                    }}
                    >
                        <div
                            className="icon-picker-grid"
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr));",
                                width: 95,
                                height: 200,
                            }}
                        >
                            <div className="icon-picker-grid-item">
                                {[...icons].map((item) => (
                                    <FontAwesomeIcon
                                        key={item}
                                        icon={item}
                                        style={{ margin: 2, fontSize: 15, cursor: "pointer" }}
                                        fixedWidth
                                        onClick={() => selectIcon(item)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </Popover>
            ) : null}
        </StyledFormControl>
    );
}

export default PTMIconPicker;
